import { Context, type Effect, type Scope } from "effect";
import type { StationClientFailure } from "../../api/station/model.ts";
import type { WorkspaceDraft, WorkspaceTarget } from "./persistence-model.ts";
import type { PendingSaveSnapshot } from "./pending-model.ts";

export interface PendingSaveSession {
  readonly read: Effect.Effect<PendingSaveSnapshot>;
  readonly schedule: (target: WorkspaceTarget, draft: WorkspaceDraft) => Effect.Effect<void, StationClientFailure>;
  readonly flush: Effect.Effect<void, StationClientFailure>;
  readonly discard: (target?: WorkspaceTarget) => Effect.Effect<void>;
}
export class PendingSaveSessions extends Context.Service<PendingSaveSessions, {
  readonly open: (notify: (state: PendingSaveSnapshot) => Effect.Effect<void>) => Effect.Effect<PendingSaveSession, never, Scope.Scope>;
}>()("workerstation/frontend/PendingSaveSessions") {}
